/** Локалізований текст у форматі, який зберігає бекенд: { uk: "...", en: "...", ... }. */
export type I18nText = Record<string, string> | null;

export interface QuestionType {
  id: number;
  name: string;
  comment: string | null;
  htmlType: string | null;
  htmlComponent: string;
  htmlAttributes: Record<string, any> | null;
}

export interface ConstructionOption {
  id: number;
  templateId: number;
  questionId: number;
  value: string;
  order: number;
  isDefault: number;
  caption: string | null;
  nestCaptionI18n: I18nText;
  noteI18n: I18nText;
}

export interface ConstructionQuestion {
  id: number;
  templateId: number;
  typeId: number;
  name: string;
  stepOrder: number;
  order: number;
  isRequired: number;
  min: number | null;
  max: number | null;
  relatedAction: string | null;
  dependency: string | null;
  pattern: string | null;
  nestCaptionI18n: I18nText;
  nestTooltipI18n: I18nText;
  nestNoteI18n: I18nText;
  nestPlaceholderI18n: I18nText;
  options: ConstructionOption[];
}

export interface ConstructionStep {
  id: number;
  templateId: number;
  order: number;
  nestCaptionI18n: I18nText;
  nestDescriptionI18n: I18nText;
  questions: ConstructionQuestion[];
}

export interface ConstructionTemplate {
  id: number;
  expertId: number | null;
  isSystem: boolean;
  status: 'draft' | 'published';
  surveysCount: number;
  expertName: string | null;
  expertAvatar: string | null;
  nestNameI18n: I18nText;
  nestDescriptionI18n: I18nText;
  nestWelcomeNotesI18n: I18nText;
  createdAt: string;
  updatedAt: string;
}

export interface ConstructionTemplateDetail extends ConstructionTemplate {
  steps: ConstructionStep[];
}

export interface AssignedClient {
  clientId: number;
  name: string;
  status: 'in_progress' | 'completed';
  completionRate: number | null;
  assignedAt: string;
}

export interface CreateTemplateDto {
  nestNameI18n?: I18nText;
  nestDescriptionI18n?: I18nText;
  nestWelcomeNotesI18n?: I18nText;
}

export type UpdateTemplateDto = Partial<CreateTemplateDto> & {
  status?: 'draft' | 'published';
};

export interface CreateStepDto {
  order: number;
  nestCaptionI18n?: I18nText;
  nestDescriptionI18n?: I18nText;
}

export type UpdateStepDto = Partial<CreateStepDto>;

export interface CreateQuestionDto {
  typeId: number;
  name: string;
  order: number;
  isRequired?: boolean;
  nestCaptionI18n: I18nText;
  nestTooltipI18n?: I18nText;
  nestNoteI18n?: I18nText;
  nestPlaceholderI18n?: I18nText;
  min?: number;
  max?: number;
  relatedAction?: string;
  dependency?: string;
  pattern?: string;
}

export type UpdateQuestionDto = Partial<CreateQuestionDto>;

export interface CreateOptionDto {
  value: string;
  order: number;
  isDefault?: boolean;
  caption?: string;
  nestCaptionI18n?: I18nText;
  noteI18n?: I18nText;
}

export type UpdateOptionDto = Partial<CreateOptionDto>;

/** Типи компонентів питання, для яких потрібен редактор варіантів відповіді. */
export const OPTIONS_COMPONENTS = ['select', 'radio', 'checkbox-group'] as const;
